<template>
  <div></div>
</template>

<script>
import userManager from '@/modules/auth/user-manager'

export default {
  name: "Logout",
  created() {
    userManager.signoutRedirect();
    localStorage.setItem('token', '');
  },
};
</script>